
<template>
	<div class="main-container">
		<div class="container">
			<section class="products-header">
				<span class="main-title">Nuevo Producto</span>
			</section>
			<section class="form">
				<div>
					<div>
						<label 
							for="category"
							class="label-modal">
							Categoria
						</label>
						<select
							placeholder="Nombre"
							class="form-input mb-10 select-style"
							v-model="newProduct.category"
							@change="filterSubcategories"
						>
							<option value="">Categoría</option>
							<option
								v-for="(cha, indexCha) in categories"
								:key="indexCha"
								:value="cha.id"
							>{{cha.title}}</option>
						</select>
					</div>
					<div>
						<label 
							for="category"
							class="label-modal">
							Sub Categoria
						</label>
						<select
							placeholder="Nombre"
							class="form-input mb-10 select-style"
							v-model="subCategoryId"
						>
							<option value="">SubCategoría</option>
							<option
								v-for="(sub, index) in subCategories"
								:key="index"
								:value="sub.id"
							>{{sub.title}}</option>
						</select>
					</div>
					<div>
						<label 
							for="name"
							class="label-modal">
							Nombre
						</label>
						<input class="form-input mb-10" v-model="newProduct.name" placeholder="Nombre"/>
					</div>
					<div>
						<label 
							for="image"
							class="label-modal">
							Adjuntar foto (vista previa)
						</label>
						<upload-image
							class="upload-image"
							label-for="image-id"
							label-ref="image-img"
							placeholder="Adjuntar foto (vista previa)"
							text-label=""
							:url-image="newProduct.image"
							:visible-more="false"
							@send-image="getFile('image', $event)"
						/>
					</div>
					<div class="wrapper-group-input">
						<div>
							<label 
								for="subtitle"
								class="label-modal">
								Subtítulo
							</label>
							<input class="form-input mb-10" v-model="newProduct.subTitle" placeholder="Subtítulo"/>
						</div>
						<div>
							<label 
								for="detail"
								class="label-modal">
								Detalles
							</label>
							<vue-editor
								placeholder="Detalles"
								class="mb-10"
								:editorToolbar="customToolbar"
								v-model="newProduct.details"></vue-editor>
						</div>
					</div>
					<div>
						<label 
							for="subtitle"
							class="label-modal">
							Titulo
						</label>
						<input 
							class="form-input mb-10" 
							v-model="properties.title" 
							placeholder="Subtítulo"/>
					</div>
					<div>
						<label 
							for="subtitle"
							class="label-modal">
							Descripción
						</label>
						<vue-editor
							placeholder="Descripción"
							class="mb-10"
							:editorToolbar="customToolbar"
							v-model="properties.description"></vue-editor>
					</div>
					<div class="wrapper-group-input">
						<div class="wrapper-flex">
							<div class="w-92">
								<label 
									for="subtitle"
									class="label-modal">
									Lista
								</label>
								<input 
									class="form-input mb-10" 
									v-model="newListProperties" 
									placeholder="Lista"/>
							</div>
							<button 
								class="btn-more"
								:class="{'disable-class': !newListProperties}"
								:disabled="!newListProperties"
								@click="addNewList('properties')">
								<img 
									src="/static/img/icon-plus.svg" 
									alt="agregar lista"
									height="20px"
									v-if="!flagEditPro">
								<img
									v-else
									src="/static/img/checked.svg"
									height="20px"
									alt="editar lista"
								>
							</button>
						</div>
						<div>
							<li 
								v-for="(item, index) in properties.list" 
								:key="index">
								<span>{{item}}</span>
								<button  @click="editList('properties', index)">
									<img 
										src="/static/img/icon-edit-dark.svg" 
										alt="editar lista"
										height="18px">
								</button>
								<button @click="deleteList('properties', index)">
									<img 
										src="/static/img/icon-close-dark.svg" 
										alt="eliminar lista"
										height="18px">
								</button>
							</li>
						</div>
					</div>
					<div class="">
						<div>
							<label 
								for="subtitle"
								class="label-modal">
								Titulo
							</label>
							<input 
								class="form-input mb-10" 
								v-model="features.title" 
								placeholder="Subtítulo"/>
						</div>
						<div>
							<label 
								for="subtitle"
								class="label-modal">
								Descripción
							</label>
							<vue-editor
								placeholder="Descripción"
								class="mb-10"
								:editorToolbar="customToolbar"
								v-model="features.description"></vue-editor>
						</div>
					</div>
					<div class="wrapper-group-input">
						<div class="wrapper-flex">
							<div class="w-92">
								<label 
									for="subtitle"
									class="label-modal">
									Lista
								</label>
								<input 
									class="form-input mb-10" 
									v-model="newListFeatures" 
									placeholder="Lista"/>
							</div>
							<button 
								class="btn-more"
								:class="{'disable-class': !newListFeatures}"
								:disabled="!newListFeatures"
								@click="addNewList('features')">
								<img 
									src="/static/img/icon-plus.svg" 
									alt="agregar lista"
									height="20px"
									v-if="!flagEditFet">
								<img
									v-else
									src="/static/img/checked.svg"
									height="20px"
									alt="editar lista">
							</button>
						</div>
						<div>
							<li 
								v-for="(item, index) in features.list" 
								:key="index">
								<span>{{item}}</span>
								<button @click="editList('features', index)">
									<img 
										src="/static/img/icon-edit-dark.svg" 
										alt="editar lista"
										height="18px">
								</button>
								<button @click="deleteList('features', index)">
									<img 
										src="/static/img/icon-close-dark.svg" 
										alt="eliminar lista"
										height="18px">
								</button>
							</li>
						</div>
					</div>
					<upload-image
						text-label=""
						placeholder="Adjuntar pdf (Etiqueta)"
						label-for="sticker-id"
						label-ref="sticker-img"
						file-type="urlFile"
						class="mb-10"
						:url-image="newProduct.pdf"
						:visible-more="false"
						@send-image="getFile('pdf', $event)"
						@delete-image="deleteFile('pdf', $event)"
					/>
					<upload-image
						placeholder="Adjuntar pdf (Hoja técnica)"
						text-label=""
						label-for="technicalSheet-id"
						label-ref="technicalSheet-img"
						file-type="urlFile"
						class="mb-10"
						:url-image="newProduct.technicalSheet"
						:visible-more="false"	
						@send-image="getFile('technicalSheet', $event)"
						@delete-image="deleteFile('technicalSheet', $event)"
					/>
				</div>
				<div>
					<upload-image
						placeholder="Adjuntar pdf (Hoja de seguridad)"
						text-label=""
						label-for="securitySheet-id"
						label-ref="securitySheet-img"
						file-type="urlFile"
						class="mb-10"
						:url-image="newProduct.securitySheet"
						:visible-more="false"
						@send-image="getFile('securitySheet', $event)"
						@delete-image="deleteFile('securitySheet', $event)"
					/>
					<div class="mb-10">
						<upload-image
							text-label=""
							placeholder="Adjuntar foto (vista previa)"
							label-for="photo-id"
							label-ref="photo-img"
							class="upload-image-width"
							:visible-more="false"
							@send-image="getFile('images', $event)"
						/>
					</div>
					<div class="all-images">
						<mini-image-component
							v-for="(img, indexImg) in newProduct.images"
							:key="indexImg"
							:image="img.source || img"
							@remove-button="removeItem(indexImg, newProduct.images)"
						/>
					</div>
				</div>
			</section>
			<section class="save">
				<button
					class="cancel-btn"
					@click="cancelFn"
				>Cancelar</button>
				<button
					class="product-btn"
					@click="createProduct"
				>Guardar</button>
			</section>
		</div>
	</div>
</template>

<script>
import { VueEditor } from 'vue2-editor';
import miniImageComponent from '@/components/commons/mini-image-component';
import uploadImage from '@/components/commons/upload-image';
import lib from '@/shared/lib';

const { removeItemFromArrayByIndex, compose, setNewProperty, buildObject } = lib;

function created() {
	if (this.$route.params.id) {
		this.id = this.$route.params.id;
	}
	this.loadData();
}

async function loadData() {
	const urlCategories = `app/${process.env.APP_CODE}/categories`;
	const urlProduct = `edit/products/${this.id}`;
	const requests = [
		this.$http.get(urlCategories),
	];
	if (this.id) {
		requests.push(this.$http.get(urlProduct));
	}
	const [
		{ data: categories },
		product,
	] = await Promise.all(requests);
	this.categories = categories.data;
	if (this.id) {
		this.fillForm(product.data.data);
	}
}

function removeItem(index, collection) {
	this.newProduct.images = removeItemFromArrayByIndex(index, collection);
}

function cancelFn() {
	this.$router.push({ name: 'products-list' });
}

function deleteFile(prop, url) {
	if (prop === 'images') {
		this.newProduct[prop].pop(url);
	} else {
		this.newProduct[prop] = null;
	}

	console.log(this.newProduct);
}

function getFile(prop, url) {
	if (prop === 'images') {
		this.newProduct[prop].push(url);
	} else {
		this.newProduct[prop] = url;
	}
}

async function createProduct() {
	const id = this.$route.params.id;
	const urlPost = `${process.env.ARIS_URL}/edit/products`;
	const urlPut = `${process.env.ARIS_URL}/edit/products/${id}`;
	const url = id ? urlPut : urlPost;
	const body = this.buildBody(this.newProduct);
	body.features = this.features;
	body.properties = this.properties;
	const methods = id ? 'put' : 'post';
	const word = id ? 'actualizado' : 'creado';
	try {
		await this.$http[methods](url, body);
		this.showNotification(`Producto ${word} con éxito`);
		this.$router.push({ name: 'products-list' });
	} catch (error) {
		this.showError();
	}
}

function buildBody(productData) {
	return compose(
		setNewProperty('categoryId', this.subCategoryId || productData.category),
		setNewProperty('title', productData.name),
		setNewProperty('codeApp', process.env.APP_CODE),
		setNewProperty('description', productData.details),
		setNewProperty('subtitle', productData.subTitle),
		setNewProperty('imagePrevious', productData.image),
		setNewProperty('dataImage', this.buildDataImage(productData.images)),
		setNewProperty('files', this.buildFiles(productData)),
	)({});
}

function buildDataImage(images) {
	return images.reduce((list, item) => {
		const source = item.source ? item.source : item;
		const obj = compose(
			setNewProperty('source', source),
			setNewProperty('title', ''),
			setNewProperty('link', ''),
			setNewProperty('subTitle', '...'),
		)({});
		return list.concat(obj);
	}, []);
}

function buildFiles(dataProduct) {
	const { pdf, securitySheet, technicalSheet } = dataProduct;
	return {
		pdfLabel: buildObject('path', 'text')(pdf, 'Descargar Etiqueta'),
		pdfSecuritySheet: buildObject('path', 'text')(securitySheet, 'Hoja de Seguridad'),
		pdfTechnicalSheet: buildObject('path', 'text')(technicalSheet, 'Hoja Técnica'),
	};
}

function fillForm(product) {
	this.newProduct = {
		category: product.category.data.categoryParentId ?
			product.category.data.categoryParentId : product.category.data.id,
		details: product.description,
		image: product.imagePrevious || '',
		images: product.dataImage ? product.dataImage.data : [],
		name: product.title,
		pdf: product.files.pdfLabel ? product.files.pdfLabel.path : '',
		securitySheet: product.files.pdfSecuritySheet ? product.files.pdfSecuritySheet.path : '',
		subTitle: product.subTitle,
		technicalSheet: product.files.pdfTechnicalSheet ? product.files.pdfTechnicalSheet.path : '',
	};
	this.subCategoryId = product.category.data.categoryParentId ? product.category.data.id : '';
	const newCategory = this.categories.find(c => c.id === this.newProduct.category);
	this.subCategories = newCategory.subCategories ? newCategory.subCategories.data : [];
	this.properties = product.properties || this.properties;
	this.features = product.features || this.features;
}

function getImageUrl() {
	return function inner(item) {
		return item.source[0];
	};
}

function filterSubcategories() {
	const newCategory = this.categories.find(c => c.id === this.newProduct.category);
	if (newCategory) {
		this.subCategories = newCategory.subCategories ? newCategory.subCategories.data : [];
	} else {
		this.subCategories = [];
	}
	this.subCategoryId = '';
}


function addNewList(list) {
	if (list === 'features') {
		if (this.flagEditFet) {
			this.features.list[this.indexFet] = this.newListFeatures;
		} else {
			const newFeature = { ...this.features };
			newFeature.list.push(this.newListFeatures);
			this.features = { ...newFeature };
		}
		this.newListFeatures = '';
	} else {
		if (this.flagEditPro) {
			this.properties.list[this.indexPro] = this.newListProperties;
		} else {
			const newProperty = { ...this.properties };
			newProperty.list.push(this.newListProperties);
			this.properties = { ...newProperty };
		}
		this.newListProperties = '';
	}
}

function deleteList(list, index) {
	if (list === 'features') {
		this.features.list.splice(index, 1);
	} else {
		this.properties.list.splice(index, 1);
	}
}

function editList(list, index) {
	if (list === 'features') {
		this.newListFeatures = this.features.list[index];
		this.flagEditFet = true;
		this.indexFet = index;
	} else {
		this.newListProperties = this.properties.list[index];
		this.flagEditPro = true;
		this.indexPro = index;
	}
}

function data() {
	return {
		categories: [],
		newProduct: {
			category: '',
			details: '',
			image: '',
			images: [],
			name: '',
			pdf: '',
			securitySheet: '',
			subTitle: '',
			technicalSheet: '',
		},
		subCategoryId: '',
		subCategories: [],
		properties: {
			title: '',
			description: '',
			list: [],
		},
		features: {
			title: '',
			description: '',
			list: [],
		},
		newListProperties: '',
		newListFeatures: '',
		flagEditPro: false,
		flagEditFet: false,
		indexPro: 0,
		indexFet: 0,
		newImage: '',
		customToolbar: [
			['bold', 'italic', 'underline'],
			[{ list: 'bullet' }],
			['link'],
		],
	};
}
export default {
	name: 'product-new',
	components: {
		VueEditor,
		miniImageComponent,
		uploadImage,
	},
	created,
	data,
	methods: {
		buildBody,
		buildDataImage,
		buildFiles,
		cancelFn,
		createProduct,
		fillForm,
		getFile,
		getImageUrl,
		loadData,
		removeItem,
		filterSubcategories,
		addNewList,
		editList,
		deleteList,
		deleteFile,
	},
};
</script>

<style lang="scss" scoped>
.main-container {
	align-items: center;
	display: flex;
	font-family: map-get($fonts, open-regular);
	justify-content: center;
	padding: 80px 25px;
}

.container {
	width: 1160px;
}

.products-header {
	align-items: center;
	border-bottom: 3px solid map-get($colors, black-dark);
	display: flex;
	justify-content: flex-start;
	margin-bottom: 41px;
	padding-bottom: 12px;
}

.form {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(490px, 1fr));
	grid-gap: 60px;
}

.mb-10 {
	margin-bottom: 10px;
}

.save {
	align-items: center;
	display: flex;
	justify-content: center;
	margin-top: 45px;
	width: 100%;
}

.product-btn,
.cancel-btn {
	background-color: map-get($colors, black-dark);
	color: white;
	font-size: map-get($sizes, medium);
	height: 45px;
	margin-right: 20px;
	width: 192px;
}

.cancel-btn {
	background-color: white;
	border: 1px solid map-get($colors, black-dark);
	color: map-get($colors, black-dark);
}

.textarea-height {
	line-height: 23px;
	height: 80px;
}

.select-style {
	background-color: white;
}

.all-images {
	display: grid;
	grid-column-gap: 28px;
	grid-row-gap: 15px;
	grid-template-columns: repeat(auto-fit, minmax(83px, 87px));
}

.add-button {
	background-color: black;
	border-radius: 3px;
	color: white;
	font-size: 30px;
	height: 30px;
		line-height: 10px;
	width: 30px;
}

.slider-container {
	align-items: center;
	border-bottom: 3px solid black;
	display: flex;
	justify-content: space-between;
		padding-bottom: 20px;
}

.upload-image-width {
	width: 100%;
}

.upload-image {
	margin-bottom: 20px;
}

.btn-more {
	background-color: #001d32;
	border-radius: 4px;
	height: 30px;
	margin-left: 15px;
	padding: 5px 0px;
	vertical-align: sub;
	width: 30px;
}

.w-92 {
	width: 92%;
}

.wrapper-flex {
	@include display-flex();
	align-items: center;
}

.disable-class {
	cursor: not-allowed;
	opacity: 0.25;
}

.wrapper-group-input {
	border-bottom: 5px solid black;
	margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/page-product-new.vue